import React, { createContext, useReducer } from 'react'

enum ActionType {
    TOOGLE_MORE_INFO,
}

interface ToggleMoreInfoAction {
    type: ActionType.TOOGLE_MORE_INFO
    payload: boolean
}

type Action = ToggleMoreInfoAction

interface State {
    isMoreInfoOpen: boolean
}

interface Dispatch {
    toggleMoreInfo: (isOpen: boolean) => void
}

interface ContextValue {
    state: State
    dispatch: Dispatch
}

export const defaultContextValue: ContextValue = {
    state: {
        isMoreInfoOpen: false,
    },
    dispatch: {
        toggleMoreInfo: () => undefined,
    },
}
const context = createContext(defaultContextValue)

const toggleMoreInfoAction = (dispatch: React.Dispatch<ToggleMoreInfoAction>, isOpen: boolean) => {
    dispatch({ type: ActionType.TOOGLE_MORE_INFO, payload: isOpen })
}

const useMoreInfoReducer = (initialState?: Partial<State>): [State, React.Dispatch<Action>] => {
    return useReducer(
        (state: State, action: Action) => {
            switch (action.type) {
                case ActionType.TOOGLE_MORE_INFO:
                    return { ...state, isMoreInfoOpen: action.payload }
            }
        },
        { ...defaultContextValue.state, ...(initialState ? initialState : {}) },
    )
}

interface Props {
    initialState?: Partial<State>
}

export const MoreInfoProvider: React.FC<Props> = ({ children, initialState }) => {
    const [state, dispatch] = useMoreInfoReducer(initialState)

    return (
        <context.Provider
            value={{
                state,
                dispatch: {
                    toggleMoreInfo: (isOpen) => toggleMoreInfoAction(dispatch, isOpen),
                },
            }}
        >
            {children}
        </context.Provider>
    )
}

export default context
